import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { storage } from "@/lib/storage";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = guest

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    check();
  }, [check]);

  const signIn = (data) => {
    storage.set("tms_admin_token", data.token);
    setUser(data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    storage.remove("tms_admin_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, signIn, logout, check }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
